import { useEffect, useReducer, useCallback, Dispatch } from 'react'
import {
  IContinuationState,
  IAction,
  ContinuationFetch,
} from '../../types/continuationScroll'
import { reducer } from '../../reducers/continuationScroll'
import { trace } from '../../services/common'

export const useContinuation = (
  getItems?: ContinuationFetch
): [IContinuationState, (items: any[], continuationToken?: string) => void] => {
  const [state, dispatch]: [IContinuationState, Dispatch<IAction>] = useReducer(
    reducer,
    {
      items: [],
      totalCount: 0,
      continuationToken: undefined,
      isLoading: false,
    }
  )
  const getNextChunk = useCallback(
    async (items: any[], continuationToken?: string) => {
      try {
        if (!!getItems) {
          dispatch({ type: 'FETCH_ITEMS__STARTED', items })
          const data = await getItems(continuationToken)
          dispatch({
            type: 'FETCH_ITEMS__SUCCESS',
            items: [...items, ...data.items],
            totalCount: data.totalCount,
            continuationToken: data.continuationToken,
          })
        }
      } catch (err) {
        dispatch({ type: 'FETCH_ITEMS__FAILURE' })
        trace(err)
      }
    },
    [getItems]
  )
  useEffect(() => {
    getNextChunk([])
  }, [getNextChunk])
  return [state, getNextChunk]
}
